// extracted by mini-css-extract-plugin
export default {"panel":"distribution-field__panel--_y8wC"};